import { FilterFieldDefinition } from '../../composables/useUrlFilters';
import { UrlFilterSerializer } from '../UrlFilterSerializer';

export const GrossProfitFilterDefinitions: FilterFieldDefinition[] = [
    {
        key: 'dateOrderOnFrom',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    },
    {
        key: 'dateOrderOnTo',
        type: 'date',
        defaultValue: null,
        serialize: UrlFilterSerializer.serializeDate,
        deserialize: UrlFilterSerializer.deserializeDate
    }
];
